export interface IProductionEstimateRequest {
    igsCustomerNumber: string;
}

export class ProductionEstimateRequest
    implements IProductionEstimateRequest {
    public igsCustomerNumber: string;

    constructor(igsCustomerNumber?: string) {
        this.igsCustomerNumber = igsCustomerNumber;
    }
}
